// extracted by mini-css-extract-plugin
module.exports = {"planningBox":"style__planningBox__7n6Ki","planningTitle":"style__planningTitle__p9VZ-","planningSteps":"style__planningSteps__zF+u0","icon":"style__icon__oAHsY"};